export default __webpack_public_path__ + "static/media/Laundry - Coral.d69d5230.svg";